import React from 'react';

import './varianceCardItem.style.css';

const varianceCardItem = ({ signedAmount, displayAmount, text }) => {
    let arrow = '';
    if (signedAmount !== 0) {
        arrow = Math.sign(signedAmount) === -1 ? 'icon-red-down-arrow' : 'icon-green-up-arrow';
    }
    return (
        <div className="VarianceCardItem">
            <div className="VarianceCardItemNumber">
                <span className={arrow} />
                <div>{displayAmount}</div>
            </div>
            <span className="VarianceCardItemLabel">{text}</span>
        </div>
    );
};

export default varianceCardItem;
